import { RatPosition } from '../enums/rat-position';

export const ratConfig = [
  {
    moveDirection: RatPosition.Left,
    floor: RatPosition.SecondFloor,
  },
  {
    moveDirection: RatPosition.Left,
    floor: RatPosition.FirstFloor,
  },
  {
    moveDirection: RatPosition.Right,
    floor: RatPosition.SecondFloor,
  },
  {
    moveDirection: RatPosition.Right,
    floor: RatPosition.FirstFloor,
  },
];
